// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5779cf73","952":"7b41082e"}[chunkId] + ".chunk.js";
};